import { createSlice } from '@reduxjs/toolkit';
import type { AppStateCommon } from '../data/interfaces/sharedmodels';
import { stat } from 'fs';


// Define the initial state using that type
const initialState: AppStateCommon = {
    IsLoading: false,
    RequestCount: 0
}
export const commonSlice = createSlice({
    name: 'common',
    initialState,
    reducers: {
        addrequestcounter: (state) => {
            state.RequestCount = state.RequestCount+1;
            if(state.RequestCount>0){
                state.IsLoading=true;
            }
        },
        reducerequestcounter: (state) => {
            state.RequestCount = state.RequestCount-1;
            if(state.RequestCount<1){
                state.IsLoading=false;
            }
        }
        
    },
});

export const { addrequestcounter, reducerequestcounter } = commonSlice.actions

export default commonSlice.reducer